/**
 * Configuração das telas, injetada no build (variáveis VITE_*). Nada de segredo aqui:
 * tudo que vai para o navegador é público. Valores por ambiente em .env.example.
 */

type Environment = "local" | "staging" | "production";

function pick(name: string, fallback: string): string {
  const value = (import.meta.env as Record<string, string | undefined>)[name];
  return value && value.length > 0 ? value : fallback;
}

export const env = {
  environment: pick("VITE_ENVIRONMENT", "local") as Environment,
  /** Hash do commit do build (liga erro e evento à versão). */
  release: pick("VITE_RELEASE", "dev"),
  apiUrl: pick("VITE_API_URL", "http://localhost:8787"),
  sentryDsn: pick("VITE_SENTRY_DSN", ""),
};
